var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{directives:[{name:"element-resize",rawName:"v-element-resize"}],ref:"container",on:{"resize":_vm.onResize}},[_c('v-sheet',{staticClass:"mx-auto echart",attrs:{"width":_vm.width,"height":_vm.height}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }